import { ClientBookingState } from "@/redux/slices/clientBooking/types";

/**
 * Persistence for a guest booking draft across a login round-trip. When the guest create
 * endpoint returns 409 { code: "ACCOUNT_EXISTS" } (the email already belongs to a completed account)
 * we stash the in-progress draft here and route the guest to login; on return the authed/guest
 * wizard restores it (see ClientBooking / GuestBooking mount) so the booking resumes instead of
 * starting over. sessionStorage (not local) so it's scoped to the tab and cleared when it closes.
 */
const STASH_KEY = "dev458:guestBookingDraft";

export const stashGuestDraft = (draft: ClientBookingState): void => {
  try {
    sessionStorage.setItem(STASH_KEY, JSON.stringify(draft));
  } catch {
    // Private-mode / quota / SSR — a failed stash just means no resume; never block the login redirect.
  }
};

export const readStashedGuestDraft = (): Partial<ClientBookingState> | null => {
  try {
    const raw = sessionStorage.getItem(STASH_KEY);
    return raw ? (JSON.parse(raw) as Partial<ClientBookingState>) : null;
  } catch {
    return null;
  }
};

export const clearStashedGuestDraft = (): void => {
  try {
    sessionStorage.removeItem(STASH_KEY);
  } catch {
    // No-op — nothing to clear if storage is unavailable.
  }
};
